export default "/images/8ccb7747ac1352d9e7f7132c35eb63d6.avif";